<template>

	<li class="nav-cart">
		<a href="javascript:;">购物车</a>
		<!--根据class改变颜色-->
		<span class="cart-empty-num cart-num">
								<i>1</i>
							</span>
		<div class="nav-cart-wrapper " v-show="showFlag">
			<div class="nav-cart-list">
				<div class="empty" v-show="!showFlag">
					<h3>购物车为空</h3>
					<p>您还没有选购任何商品，现在前往商城选购吧!</p>
				</div>
				<div class="full">
					<div class="nav-cart-items">
						<ul>
							<li class="clear" v-for="(item,index) in carGoodsData">
								<div class="cart-item js-cart-item cart-item-sell">
									<div class="cart-item-inner">
										<div class="item-thumb">
											<img src="../assets/img/goods/1.png">
										</div>
										<div class="item-desc">
											<div class="cart-cell">
												<h4> 
													<a href="#/item/100027401">{{item.title}}</a>
												</h4>
												<p class="attrs">
													<span>透明</span>
												</p>
												<h6>
												 <span class="price-icon">¥</span><span class="price-num">49</span><span class="item-num">x 1</span>
												</h6>
											</div>
										</div>
										<div class="del-btn">删除</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div class="nav-cart-total">
						<p>共 <strong class="ng-binding">1</strong> 件商品</p>
						<h5>合计：<span class="price-icon">¥</span><span class="price-num ng-binding" ng-bind="cartMenu.totalPrice">49</span></h5>
						<h6>
						<a ng-href="http://www.smartisan.com/shop/#/cart" class="nav-cart-btn" href="http://www.smartisan.com/shop/#/cart">去购物车</a>
						</h6>
					</div>
				</div>
			</div>
		</div>
	</li>
</template>

<script>
	export default {
		data() {
			return {
				showFlag: true
			}
		},
		computed:{
			carGoodsData(){
				return this.$store.state.carPanelData;
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/car-panel.vue